import { render, staticRenderFns } from "./BwfComponent.vue?vue&type=template&id=6025c75e&scoped=true&"
import script from "./BwfComponent.vue?vue&type=script&lang=js&"
export * from "./BwfComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6025c75e",
  null
  
)

export default component.exports